import Table from "@/components/Table/table";
import {
  MotifButton,
  MotifIcon,
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifProgressLoader,
} from "@ey-xd/motif-react";
import { IconoirWarningTriangle } from "@ey-xd/motif-icon";
import { useEffect, useState } from "react";
import {
  useGetClassFilterViewApiDataQuery,
  useDeleteClassFilterMutation,
} from "./calculationStepReducer";
import { ClassFilterType } from "./type";
import FormModalClassFilter from "./FormModal/FormModalClassFilter";
import ConfirmationModal from "@/components/Modal/ConfirmationModal/ConfirmationModal";
import FormModalClassFilterNew from "./FormModal/FormModalClassFilterNew";
import { useTranslation } from "react-i18next";
import {
  havingAddPermission,
  havingDeletePermission,
  havingEditPermission,
} from "@/utility/common";
import {
  CANCEL_BUTTON_VARIANT,
  CREATE_BUTTON_VARIANT,
  GetCommonDeleteImgButton,
  YES_BUTTON_VARIANT,
} from "@/components/Images/CommonImages";
import { useTrans } from "@/components/Functions/dateFunc";
import { useNavigate } from "react-router-dom";

type ClassFilterProps = {
  resolvedStatus: boolean;
  caseId: string;
  stepId: string;
  StepClassFilter?: string[];
};

export const ClassFilter = ({
  resolvedStatus,
  caseId,
  stepId,
  StepClassFilter,
}: ClassFilterProps) => {
  const [isVisibleCancel, setIsVisibleCancel] = useState(false);
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [isVisible1, setIsVisible1] = useState(false);
  const nav = useNavigate();
  const [isRefetch, setIsRefetch] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [selectedClassId, setSelectedClassId] = useState("");
  const [isNew, setIsNew] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteEntityName, setDeleteEntityName] = useState<any>("");
  const TitleComplement = () => {
    return havingAddPermission(StepClassFilter || []) ? (
      <MotifButton
        onClick={() => {
          setIsVisible(true);
          setIsVisible1(false);
          setIsNew(true);
          setIsEdit(false);
        }}
        size="small"
        type="submit"
        variant={CREATE_BUTTON_VARIANT}
        disabled={resolvedStatus}
      >
        {t(
          "pages.distributions.distributionStepsTab.classFilterTab.createClassFilter"
        )}
      </MotifButton>
    ) : (
      <></>
    );
  };

  const { data, isLoading, refetch, isFetching } =
    useGetClassFilterViewApiDataQuery(stepId);

  const selectedScheme =
    data && data.length > 0 ? data[0].schemeVersionId : undefined;
  const editSelectedScheme =
    data && data.length > 1 ? data[0].schemeVersionId : undefined;

  const selectedClass =
    data && data.length > 0 ? data.map((item: any) => item.classId) : null;

  const sourceData: ClassFilterType[] = [];

  useEffect(() => {
    if (isRefetch) {
      refetch();
      setIsRefetch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRefetch]);
  if (data && data.length > 0) {
    // eslint-disable-next-line array-callback-return
    data.map((item: any) => {
      let obj = {
        weight: "",
        className: "",
        id: "",
        schemeId: "",
      };
      obj.className = item?.className ? item?.className : "-";
      obj.weight =
        item.weight !== null && item.weight !== "" ? "" + item.weight : "-";
      obj.id = item.id ? item.id : "";
      obj.schemeId = item.schemeId ? item.schemeId : "";
      sourceData.push(obj);
    });
  }
  const [deleteClassFilter, { isLoading: deleteLoading }] =
    useDeleteClassFilterMutation();
  async function deleteClassFilterHandler(Id: string) {
    const response = await deleteClassFilter(Id);
    if (response.hasOwnProperty("data")) {
      refetch();
    } else {
      console.log("Error in deleting class filter");
    }
    setShowModal(false);
  }

  const headerData = {
    title: "Class Filters",
    description: "Descriptive text that describes your page or content.",
  };

  const handleEdit = (id: any) => {
    setIsVisible1(true);
    setIsVisible(false);
    setSelectedClassId(id);
    setIsEdit(true);
    setIsNew(false);
  };
  const transFunction = useTrans(
    t,
    t(
      "pages.distributions.distributionStepsTab.classFilterTab.deleteWarningMessage",
      {
        deleteEntityName: deleteEntityName,
      }
    ),
    "deleteEntityName"
  );
  const ActionsCellRenderer = (params: any) => {
    return (
      <>
        <div
          onClick={() => {
            if (havingEditPermission(StepClassFilter || [])) {
              handleEdit(params?.data.id);
            }
          }}
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "end",
            cursor: havingEditPermission(StepClassFilter || [])
              ? "pointer"
              : "default",
          }}
        >
          <div className="pad-r-10">
            {havingDeletePermission(StepClassFilter || []) && (
              <GetCommonDeleteImgButton
                tooltipPlacment="left"
                onClick={(e: any) => {
                  e.stopPropagation();
                  setShowModal(true);
                  setDeleteId(params?.data?.id);
                  setDeleteEntityName(params?.data?.className);
                }}
                disabled={resolvedStatus}
              ></GetCommonDeleteImgButton>
            )}
          </div>
        </div>
        {/* <div className="pad-r-10">
          {havingEditPermission(StepClassFilter || []) &&  <MotifButton
            size="small"
            variant="secondary"
            onClick={() => handleEdit(params?.data.id)}
            disabled={resolvedStatus}
          >
            <MotifIcon fill="none" iconFunction={contentIcCreate24px} />
          </MotifButton>}
      </div> */}
      </>
    );
  };

  const columnClassFilterDefs = [
    {
      field: "className",
      headerName: t(
        "pages.distributions.distributionStepsTab.classFilterTab.columnDetails.column1"
      ),
      sortable: true,
      sort: "asc",
      unSortIcon: true,
      flex: 2,
      cellClass: "align-left",
      cellRenderer: function (params: any) {
        return (
          <div
            onClick={(e) => {
              e.stopPropagation();
              e.cancelable = true;
              if (havingEditPermission(StepClassFilter || [])) {
                handleEdit(params?.data.id);
              }
            }}
            style={{
              width: "100%",
              cursor: havingEditPermission(StepClassFilter || [])
                ? "pointer"
                : "default",
            }}
          >
            <span
              onClick={(e) => {
                nav(
                  `/case/${caseId}/scheme-manage/${params?.data.schemeId}/?activeTab=0`
                );
              }}
              style={{
                cursor: "pointer",
              }}
              className={"text-bold-underline"}
            >
              {params?.data.className}
            </span>
          </div>
        );
      },
    },

    {
      headerName: t(
        "pages.distributions.distributionStepsTab.classFilterTab.columnDetails.column2"
      ),
      field: "weight",
      flex: 1,
      headerClass: "stepHeaderClass",
      cellClass: "align-right",
      onCellClicked: (params: any) => {
        if (havingEditPermission(StepClassFilter || [])) {
          handleEdit(params?.data.id);
        }
      },
      cellStyle: {
        cursor: havingEditPermission(StepClassFilter || [])
          ? "pointer"
          : "default",
      },
    },
    {
      cellRenderer: ActionsCellRenderer,
      field: "action",
      headerName: "",
      flex: 1,
      sortable: false,
      cellClass: "align-right",
    },
  ];

  if (isLoading) {
    return <MotifProgressLoader show variant="default" />;
  }

  const cancelBtnApproveHandler = () => {
    setIsVisibleCancel(false);
  };

  return (
    <>
      <div>
        {isLoading ? (
          <MotifProgressLoader show variant="default" className="mar-b-20" />
        ) : (
          <div className="mar-b-20 mar-t-20">
            <MotifModal
              onClose={() => setShowModal(false)}
              show={showModal}
              focusTrapOptions={{
                tabbableOptions: {
                  displayCheck: "none",
                },
              }}
            >
              <div className="confirmationModalWrapper creditor_disabling_model">
                <MotifModalHeader
                  headerIcon={
                    <>
                      <span
                        style={{
                          backgroundColor: "rgb(252, 245, 243)",
                          borderRadius: "50px",
                          padding: "5px 8px 2px 8px",
                        }}
                      >
                        <MotifIcon
                          iconFunction={IconoirWarningTriangle}
                          strokeWidth="1"
                          size="15"
                          stroke="red"
                        />{" "}
                      </span>
                      <span
                        style={{
                          fontSize: 16,
                          display: "block",
                          width: "100%",
                          marginLeft: "10px",
                        }}
                      >
                        {t("global.globalNotifications.warning")}{" "}
                      </span>
                    </>
                  }
                ></MotifModalHeader>

                <MotifModalBody style={{ paddingTop: "0px" }}>
                  <span style={{ fontWeight: "300" }}>{transFunction}</span>
                </MotifModalBody>
                <MotifModalFooter>
                  <MotifButton
                    size="small"
                    type="submit"
                    variant={YES_BUTTON_VARIANT}
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                    }}
                    loading={deleteLoading}
                    onClick={() => {
                      deleteClassFilterHandler(deleteId);
                    }}
                  >
                    {t("global.globalActions.yes")}
                  </MotifButton>
                  <MotifButton
                    className=""
                    onClick={() => setShowModal(false)}
                    size="small"
                    type="button"
                    variant={CANCEL_BUTTON_VARIANT}
                  >
                    {t("global.globalActions.cancel")}
                  </MotifButton>
                </MotifModalFooter>
              </div>
            </MotifModal>
            <Table
              columnDefs={columnClassFilterDefs}
              cellRenderers={isFetching ? [] : sourceData}
              TitleComplement={TitleComplement}
              title={
                "pages.distributions.distributionStepsTab.classFilterTab.tableTitle"
              }
              description={
                "pages.distributions.distributionStepsTab.classFilterTab.tableDescription"
              }
              caseRenderers={headerData}
              pagination={false}
              overlayNoRowsTemplate={
                isFetching
                  ? t("global.globalNotifications.loadingMessage")
                  : t("global.globalNotifications.noRecords")
              }
            />
          </div>
        )}
        <ConfirmationModal
          isVisible={isVisibleCancel}
          setIsVisible={setIsVisibleCancel}
          cancelBtnApproveHandler={cancelBtnApproveHandler}
          cancelBtnRejectHandler={() => {
            setIsVisibleCancel(false);
          }}
        />
        {isEdit && (
          <FormModalClassFilter
            isVisible={isVisible1}
            setIsVisible={setIsVisible1}
            formData={null}
            caseId={caseId}
            stepId={stepId}
            selectedClass={selectedClass}
            setIsRefetch={setIsRefetch}
            selectedClassId={selectedClassId}
            setSelectedClassId={setSelectedClassId}
            setIsEdit={setIsEdit}
            selectedScheme={editSelectedScheme}
            resolvedStatus={resolvedStatus}
          />
        )}
        {isNew && (
          <FormModalClassFilterNew
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            formData={null}
            caseId={caseId}
            stepId={stepId}
            selectedClass={selectedClass}
            setIsRefetch={setIsRefetch}
            setSelectedClassId={setSelectedClassId}
            isNew={isNew}
            setIsNew={setIsNew}
            selectedScheme={selectedScheme}
          />
        )}
      </div>
    </>
  );
};
export default ClassFilter;
